import React, { useState } from "react";
import skillCardData from "../utils/skillCardData";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import styled from "styled-components";

const DashBoardRight = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // const topic = useSelector((state) => state.endpoint.endpoint.topic);
    // const difficulty = useSelector((state) => state.endpoint.endpoint.difficulty);

    const [topic, setTopic] = useState('');
    const [difficulty, setDifficulty] = useState('');
    const [noOfQuestions, setNoOfQuestions] = useState('');

    const [activeTopicBtn, setActiveTopicBtn] = useState(null);
    const [activeDiffBtn, setActiveDiffBtn] = useState(null);
    const [activeNoOfQueBtn, setActiveNoOfQueBtn] = useState(null);

    const handleTopicBtnClick = (btnIndex, topic) => {
        setActiveTopicBtn(btnIndex);
        setTopic(topic);
    };

    const handleDiffBtnClick = (btnIndex, diff) => {
        setActiveDiffBtn(btnIndex);
        setDifficulty(diff);
    };

    const handleNoOfQueBtnClick = (btnIndex, queNo) => {
        setActiveNoOfQueBtn(btnIndex);
        setNoOfQuestions(queNo);
    }

    const handleStartTest = () => {
        if (topic && difficulty) {
            navigate(`/practice/${topic}/${difficulty}/${noOfQuestions}`);
        } else {
            toast.warning("Please Choose topic and difficulty to start test", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                className: "toastify",
            });
            return;
        }
    };

    return (
        <Box>
            <div className="dashRightHeader">
                <div className="left">
                    <span className="title">Let's start a quick test</span>
                    <span className="subtitle">Choose the Topic</span>
                </div>
                <button onClick={() => handleStartTest()} style={{ cursor: "pointer" }}>
                    Start Test →
                </button>
            </div>
            <br />
            <div className="topicBtns">
                {skillCardData.map((skill, index) => (
                    <button
                        className={
                            activeTopicBtn === index ? "topicBtn activeTopicBtn" : "topicBtn"
                        }
                        onClick={() => handleTopicBtnClick(index, skill.endpointTopic)}
                    >
                        {skill.title.toUpperCase()}
                    </button>
                ))}
            </div>
            <span className="subtitle">Choose difficulty level</span>
            <br />
            <br />
            <div className="topicBtns">
                {["Easy", "Medium", "Hard"].map((diff, index) => (
                    <button
                        onClick={() => handleDiffBtnClick(index, diff.toLowerCase())}
                        className={
                            index === activeDiffBtn ? "topicBtn activeTopicBtn" : "topicBtn"
                        }
                    >
                        {diff}
                    </button>
                ))}
            </div>

            <span className="subtitle">Choose Number of Questions</span>
            <br />
            <br />
            <div className="topicBtns">
                {[5, 10, 25].map((que, i) => (
                    <button
                        onClick={() => handleNoOfQueBtnClick(i, que)}
                        className={
                            i === activeNoOfQueBtn ? "topicBtn activeTopicBtn" : "topicBtn"
                        }>
                        {que}
                    </button>
                ))}
            </div>
        </Box>
    );
};

export default DashBoardRight;


const Box = styled.div`
  border: 1.5px solid grey;
  padding: 1rem 3%;
  margin-top: 2rem;
  margin-bottom: 2rem;
  border-radius: 1rem;
  grid-column: 2/3;
  grid-row: 1/3;
  box-sizing: border-box;

.dashRightHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  button {
    padding: 1rem 1.4rem;
    border-radius: 0.5rem;
    background-color: var(--orange);
    color: #faf9f6;
    border-style: none;
    font-size: 2rem;
  }

  .left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
}

.title {
  font-size: 3rem;
  font-weight: 600;
}

.subtitle {
  font-size: 1.75rem;
  font-style: 600;
  color: grey;
}


.topicBtns {
  display: flex;
  flex-flow: row wrap;
  column-gap: 1.75rem;
}

.topicBtn {
  padding: 0.75rem 1rem;
  margin-bottom: 2rem;
  min-width: 5vw;
  border-radius: 0.3rem;
  border-style: none;
  font-size: 1.5rem;
  font-weight: 500;
  background-color: var(--background-color);
  color: var(--color);
  border: 0.15rem solid var(--color);
  cursor: pointer;
}


.activeTopicBtn {
  background-color: var(--orange) !important;
  border-color: var(--orange) !important;
  color: #FEFFFE;
}

@media (max-width: 800px) {
  .dashBoardRight {
    grid-column: 1/3;
    grid-row: 1/2;
    font-size: 2.5rem;
  }
}



`

